import { encodeUrlFromRouter, encodeUrlToRouter } from "@/routerUrlEncoding";
import syncRecordsSavedOffline from "@/employee/dm/syncDmRecords";

import axios from "axios";

export default {
  name: "DmSelectRecord",
  components: {
    CircleLoadingIndicator:
      require("@/customcontrols/circleLoadingIndicator/circleLoadingIndicator.vue")
        .default,
    BackButton: require("@/components/backButton/backButton.vue").default,
    DmSelectRecordListCell:
      require("@/employee/dm/newDebtManagement/dmSelectRecord/dmSelectRecordListCell.vue")
        .default,
    SearchWindow:
      require("@/employee/dm/newDebtManagement/dmSearchModal/dmSearchModal.vue")
        .default,
    ErrorDialog:
      require("@/employee/captureMeterReadings/errorDisplayDialog/errorDisplayDialog.vue")
        .default,
  },
  props: {},
  data: function () {
    return {
      existingMeterItems: [],
      backUrl: "",
      selectedRecord: {
        book: null,
        walk: null,
        batch: null,
        billGroup: null,
        stage: null,
      },
      records: [],
      isLoading: false,
      selectedItemId: -1,
      showSearchDialog: false,
      settings: {},
      synchronizing: false,
      showErrorDialog: false,
      errorsObject: { sms: [], readings: [], photos: [] },
      onLine: true,
      onLineTimerCheck: null,
      navigatorConnection: { effectiveType: null, downlinks: null },
      displayType: { text: null, color: null },
    };
  },
  computed: {},
  watch: {
    onLine: function (value) {
      if (value) {
        this.$oldAlertMsg(this.$t("messages.online"), 1);
        this.saveOfflineReadings();
      } else {
        this.$oldAlertMsg(this.$t("messages.offline"), 1);
        this.showMap = false;
      }
    },
  },
  created() {
    this.init();
  },
  mounted() {
    this.onLineTimerCheck = setInterval(() => {
      this.isConsideredOnline();
    }, 1000);

    this.saveOfflineReadings();
    this.getSelectedItem();
  },
  methods: {
    async init() {
      this.selectedRecord.billGroup = encodeUrlFromRouter(
        this.$route.params.billGroup
      );
      this.selectedRecord.stage = encodeUrlFromRouter(this.$route.params.stage);
      this.selectedRecord.batch = encodeUrlFromRouter(this.$route.params.batch);
      this.selectedRecord.book = encodeUrlFromRouter(this.$route.params.book);
      this.selectedRecord.walk = encodeUrlFromRouter(this.$route.params.walk);

      this.backUrl = `debtManagementSelectWalk/${encodeUrlToRouter(
        this.selectedRecord.billGroup
      )}/${encodeUrlToRouter(this.selectedRecord.stage)}/${encodeUrlToRouter(
        this.selectedRecord.batch
      )}`;
      this.isLoading = true;

      this.displayType = {
        text:
          this.selectedRecord.stage == 5
            ? `(${this.$t("disconnections.Reconnections")})`
            : this.selectedRecord.stage == 2
            ? `(${this.$t("disconnections.Disconnections")})`
            : null,

        color:
          this.selectedRecord.stage == 5
            ? "color-blue-text"
            : this.selectedRecord.stage == 2
            ? "color-red-text"
            : null,
      };

      await this.getSettings();
      await this.getRecords();
    },
    getSelectedItem() {
      let selection = this.$store.getters.getDmSelectionSettings;
      if (selection) {
        if (selection.recSeq) {
          this.selectedItemId = selection.recSeq;
        }
      }
    },
    getSettings() {
      let id = "debtManagementSettings";

      if (navigator.onLine) {
        axios
          .post("/DmConnection/GetSettings")
          .then((response) => {
            if (response.data.data.status == 0) {
              this.settings = response.data.value;

              let userProf = this.$store.getters.getUserProfile;
              this.settings["printNotice"] =
                userProf && userProf.printNotice == true ? true : false;
              this.settings["profileId"] = userProf.profileId;

              this.$store.state.debtManagementLocalDB
                .get(id)
                .then((doc) => {
                  this.$store.state.debtManagementLocalDB.put({
                    _id: doc._id,
                    _rev: doc._rev,
                    settings: this.settings,
                  });
                })
                .catch((err) => {
                  if (err.status == 404) {
                    this.$store.state.debtManagementLocalDB.put({
                      _id: id,
                      settings: this.settings,
                    });
                  }
                });
            } else {
              this.$alertMsg(response.data.data.text);
            }
          })
          .catch((e) => {
            this.$router.push("/login");
          });
      } else {
        this.$store.state.debtManagementLocalDB
          .get(id)
          .then((doc) => {
            this.records = doc.records;
          })
          .catch((err) => {
            this.$router.push("/login");
          });
      }
    },
    getRecords() {
      let id = `dm_${this.selectedRecord.batch}_${this.selectedRecord.book}_${this.selectedRecord.walk}`;
      this.records = [];

      if (navigator.onLine) {
        let param = {
          batchNo: encodeUrlToRouter(this.selectedRecord.batch),
          bookId: encodeUrlToRouter(this.selectedRecord.book),
          walkId: encodeUrlToRouter(this.selectedRecord.walk),
          stage: encodeUrlToRouter(this.selectedRecord.stage),
          billGroup: encodeUrlToRouter(this.selectedRecord.billGroup),
        };

        axios
          .post("/DmConnection/GetEmployeeWalkRecords", param)
          .then((response) => {
            if (response.status == 200) {
              response.data.forEach((r) => {
                r["isSynced"] = false;
                r["hasPic"] = false;
                r["isAllowDisconReconWithoutReading"] = this.settings
                  .isAllowDisconReconWithoutReading
                  ? this.settings.isAllowDisconReconWithoutReading
                  : false;
                r["isRemoveInstallMeter"] = this.settings.isRemoveInstallMeter
                  ? this.settings.isRemoveInstallMeter
                  : false;
                r["installMeterId"] =
                  r.installMeterId && r.installMeterId > -1
                    ? r.installMeterId
                    : -1;
                r["readonly"] = false;
                r["isSaved"] = false;
                r["stage"] = this.selectedRecord.stage;
                r["isEdited"] = false;
                r["isUnderInvestigation"] = r.status == 3 ? true : false;
                r["removeFromInvestigation"] = false;
              });

              this.records = response.data;

              this.$store.state.debtManagementLocalDB
                .get(id)
                .then((doc) => {
                  this.$store.state.debtManagementLocalDB.put({
                    _id: doc._id,
                    _rev: doc._rev,
                    batchId: this.selectedRecord.batch,
                    bookId: this.selectedRecord.book,
                    walkId: this.selectedRecord.walk,
                    records: this.records,
                  });
                })
                .catch((err) => {
                  if (err.status == 404) {
                    this.$store.state.debtManagementLocalDB.put({
                      _id: id,
                      batchId: this.selectedRecord.batch,
                      bookId: this.selectedRecord.book,
                      walkId: this.selectedRecord.walk,
                      records: this.records,
                    });
                  }
                });
            } else this.$oldAlertMsg(this.$t("disconnections.RecordsError"));
          })
          .catch((e) => {
            this.$oldAlertMsg(this.$t("disconnections.RecordsError"));
          })
          .finally(() => {
            this.isLoading = false;

            if (this.selectedItemId > 0)
              setTimeout(() => {
                this.$scrollToElement(this.selectedItemId);
              }, 1000);
          });
      } else {
        this.$store.state.debtManagementLocalDB
          .get(id)
          .then((doc) => {
            this.records = doc.records;
          })
          .catch((err) => {
            this.$oldAlertMsg(this.$t("disconnections.RecordsError"));
          })
          .finally(() => {
            this.isLoading = false;

            if (this.selectedItemId > 0)
              setTimeout(() => {
                this.$scrollToElement(this.selectedItemId);
              }, 1000);
          });
      }
    },

    openSearch() {
      this.showSearchDialog = true;
    },
    recordSelected(item, obj) {
      if (!item) return;

      this.$store.dispatch("setDmSelectionSettings", { recSeq: item.sequence });
      let route = `/debtManagementEditRecord/${encodeUrlToRouter(
        this.selectedRecord.billGroup
      )}/${encodeUrlToRouter(this.selectedRecord.stage)}/${encodeUrlToRouter(
        this.selectedRecord.batch
      )}/${encodeUrlToRouter(this.selectedRecord.book)}/${encodeUrlToRouter(
        this.selectedRecord.walk
      )}/${encodeUrlToRouter(item.sequence)}`;
      this.$router.push(route);
    },

    async saveOfflineReadings() {
      let onLine =
        navigator.onLine &&
        (navigator["connection"]["effectiveType"] === "3g" ||
          navigator["connection"]["effectiveType"] === "4g");

      if (onLine == true) {
        this.synchronizing = true;

        let db = this.$store.state.debtManagementLocalDB;
        this.errorsObject = await syncRecordsSavedOffline(db, this.settings);

        if (
          this.errorsObject.sms.length > 0 ||
          this.errorsObject.readings.length > 0 ||
          this.errorsObject.photos.length > 0
        )
          this.showErrorDialog = true;

        this.synchronizing = false;
      }
    },
    isConsideredOnline() {
      let navOnline = navigator.onLine;

      this.navigatorConnection = {
        downlink: navigator["connection"]["downlink"],
        effectiveType: navigator["connection"]["effectiveType"],
      };

      this.onLine =
        navOnline &&
        (this.navigatorConnection.effectiveType === "3g" ||
          this.navigatorConnection.effectiveType === "4g");
      this.$store.commit("setCsAppsOfflineMode", { status: !this.onLine });

      //console.log("#", this.onLineCounter, " -- navigator.onLine", navOnline, "(", this.navigatorConnection.effectiveType, ") - onLine", this.onLine);
    },
  },
};
